import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { useAppContext } from "../Contexts/AppContext";
import { useRegistrationContext } from "../Contexts/RegistrationContext";
import { config, IInputFieldConfig } from "../Map/config";
import { getFirstAllowedWorkday, addDays } from "../Map/utils";
import { Input, PageId } from "../Map/enums";
import { IEsriFieldInfo, updateFeatures } from "../Map/rest";
import { UploadSection } from "../Registration/SummarySection";
import { Form } from "./Form";
import "./TermForm.scss";

const formId = PageId.TermForm;

export const TermForm = (): JSX.Element => {
    const [isFormValid, setIsFormValid] = useState<number>(null);
    const [formData, setFormData] = useState({});
    const [error, setError] = useState<boolean>(false);

    const { fieldInfos } = useAppContext();

    const {
        formFeature,
        rawData,
        setRawData,
        setOverlay,
        validateForm,
        resetForm,
        onFormUpdated,
        setProceedClicked,
        proceedClicked
    } = useRegistrationContext();

    useEffect(() => {
        setMinMaxDay();
    }, [formFeature]);

    useEffect(() => {
        if (isFormValid && !formFeature) {
            console.log("Can not update feature without OBJECTID");
            setError(true);
            return;
        }
        isFormValid && proceedClicked && onFormValid();
    }, [isFormValid, proceedClicked]);

    const onFormValid = async () => {
        setOverlay({ isLoading: true });
        const updateResults = await updateFeatures([appendFormData()], "3");
        if (!updateResults[0].success) {
            return;
        }
        setOverlay(null);
        onFormUpdated();
    };

    const appendFormData = useCallback(() => {
        const newprops = {};
        config.forms.termForm.fields.map((field) => {
            newprops[field.field] =
                field.type === Input.Checkbox
                    ? convertBooleanToCodedValue(
                          fieldInfos.find((info) => info.name === field.field),
                          field,
                          formData
                      )
                    : formData[field.field];
        });
        formFeature.setProperties(newprops);
        return formFeature;
    }, [formData]);

    const onFormValidated = (isValid: boolean) => {
        isValid ? setFormData(rawData) : setProceedClicked(false);
        setIsFormValid(isValid ? Date.now() : null);
    };

    const onFormChanged = (data) => {
        const dateFields = config.forms.termForm.fields.filter(
            (f) => f.type === Input.Date && (f.maxDateField || f.minDateField)
        );
        dateFields && validateDateFromTo(data, dateFields);

        setRawData(data);
    };

    const validate =
        ((validateForm.split("-")[0] as unknown) as PageId) === formId ? Number(validateForm.split("-")[1]) : 1;

    return (
        <>
            <div className="term-section">
                <br />
                <div>
                    Ar cirsmas izstrādi saistīto darbību (sortimentu pievešana, nokraušana, transportēšana) LVM meža
                    zemē un/vai meža ceļu izmantošanu drīkst uzsākt tikai pēc rakstiska LVM saskaņojuma saņemšanas uz
                    Jūsu norādīto pasta vai elektronisko pasta adresi.
                </div>
                <b>Pieteikuma apstrādes un izskatīšanas termiņš ir aptuveni 5 darba dienas.</b>
            </div>
            <Form
                fieldConfig={config.forms.termForm}
                onChange={onFormChanged}
                validateForm={validate}
                onFormValidated={onFormValidated}
                resetForm={resetForm}
                formValues={Object.keys(rawData).length ? rawData : null}
            ></Form>
            <UploadSection classname={"upload-section term-form"} title={"Pielikumi"}></UploadSection>
            {error ? <div className="network-error">Kļūda servera savienojumā!</div> : null}
        </>
    );
};

const validateDateFromTo = (data, dateFields) => {
    Object.keys(data).map((item) => {
        if (!dateFields.find((dataField) => dataField.field === item)) {
            return;
        }

        const currentFieldConfig = config.forms.termForm.fields.find((f) => f.field === item);

        if (currentFieldConfig.maxDateField || currentFieldConfig.minDateField) {
            config.forms.termForm.fields.map((f) => {
                f.field === currentFieldConfig.maxDateField && (f.minDate = data[item]);
                f.field === currentFieldConfig.minDateField && (f.maxDate = data[item]);
            });
        }

        if (currentFieldConfig.minDateField && data[currentFieldConfig.minDateField]) {
            const isDateValid = data[item] >= data[currentFieldConfig.minDateField];

            config.forms.termForm.fields.map((f) => {
                f.field === currentFieldConfig.minDateField &&
                    (f.hasError = currentFieldConfig.hasError = !isDateValid);
            });
        }
        if (currentFieldConfig.maxDateField && data[currentFieldConfig.maxDateField]) {
            const isDateValid = data[item] <= data[currentFieldConfig.maxDateField];

            config.forms.termForm.fields.map((f) => {
                f.field === currentFieldConfig.maxDateField &&
                    (f.hasError = currentFieldConfig.hasError = !isDateValid);
            });
        }
    });
};

const convertBooleanToCodedValue = (fieldConfig: IEsriFieldInfo, f: IInputFieldConfig, formData) =>
    fieldConfig && fieldConfig.domain && fieldConfig.domain.codedValues
        ? fieldConfig.domain.codedValues.find((cv) =>
              formData[f.field] ? cv.name.toUpperCase() === "JĀ" : cv.name.toUpperCase() === "NĒ"
          ).code
        : formData[f.field];

const getDate = (date: Date) => {
    return (
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        date.getDate().toString().padStart(2, "0")
    );
};
const setMinMaxDay = () => {
    config.forms.termForm.fields.map((f) => {
        if (f.field === "DATEFROM" || f.field === "DATETO") {
            f.minDate = getDate(getFirstAllowedWorkday(5));
            f.maxDate = getDate(addDays(new Date(Date.now()), 365));
        }
    });
};
